import localStorageKeys from './localStorageKeys';

export const getFullDateFormat = () => {
  const dateFormat = localStorage.getItem(localStorageKeys.fullDateNotation);
  const date = dateFormat?.replace('DD', 'dd')?.replace('YYYY', 'yyyy');
  return date || 'MMM dd, yyyy';
};

export const getMonthAndYearFormat = () => {
  const dateFormat = localStorage.getItem(
    localStorageKeys.monthAndYearDateNotation
  );
  const date = dateFormat?.replace('YYYY', 'yyyy');
  return date || 'MMM, yyyy';
};

export const getDayAndMonthFormat = () => {
  const dateFormat = localStorage.getItem(
    localStorageKeys.dayAndMonthDateNotation
  );
  return dateFormat || 'MMM dd';
};

export const getFullHoursDateNotation = () => {
  const dateFormat = localStorage.getItem(
    localStorageKeys.fullHoursDateNotation
  );
  const date = dateFormat?.replace('DD', 'dd')?.replace('YYYY', 'yyyy');
  return date || 'EEEE, MMMM dd, yyyy HH:mm';
};

export const getDayMonthYearWeekdayFormat = () => {
  const dateFormat = localStorage.getItem(
    localStorageKeys.dayMonthYearWeekdayNotation
  );
  const date = dateFormat?.replace('DD', 'dd')?.replace('YYYY', 'yyyy');
  return date || 'EEEE dd MMMM, yyyy';
};

export const getTimeFormat = () => {
  const dateFormat = localStorage.getItem(localStorageKeys.TimeNotation);
  return dateFormat || 'HH:mm';
};

export const getCurrencyFormat = () => {
  const currencyFormat = localStorage.getItem(localStorageKeys.currency);
  return currencyFormat || '$';
};

export const getMetricSystem = () => {
  const isMetric = localStorage.getItem(localStorageKeys.isMetric);
  return isMetric === 'true';
};
